module.exports = __webpack_public_path__ + "img/sex2.f98acda0.png";